import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { AdminSearch } from 'src/app/shared/models/admin-search.model';
import { AdminBulkAction } from 'src/app/shared/models/admin-bulk-action.model';
import { MessageDisplayModel } from 'src/app/shared/message/messageDisplay.model';
import { MessageDisplayService } from 'src/app/shared/services/message-display.service';
import { GeneralDialogComponent } from 'src/app/shared/dialog/general-dialog.component';
import { User } from 'src/app/shared/models/user.model';
import { UserService } from 'src/app/shared/services/user.service';
import { UserSearchResponse } from 'src/app/shared/models/user-search-response.model';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { Subscription } from 'rxjs';
import { AdminUserFactory } from 'src/app/shared/factories/admin-user.factory';
import { ModifyUserParams } from 'src/app/shared/models/modify-user-params.model';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { Permissions } from 'src/app/shared/models/permissions.model';
import { AdminRolesCompaniesService } from 'src/app/shared/services/admin-roles-companies.service';
import { OAuthUserInfo } from 'src/app/shared/models/oauthuserinfo.model';
import { TableComponent } from 'src/app/shared/table/table.component';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-admin-main',
  styleUrls: ['./admin-main.component.scss'],
  templateUrl: './admin-main.component.html',
})
export class AdminMainComponent implements OnInit, AfterViewInit {
  @ViewChild(GeneralDialogComponent, { static: false })
  private confirmDialog: GeneralDialogComponent;
  @ViewChild(TableComponent, { static: false }) tableComponent: TableComponent;

  currentSearch: AdminSearch = {};
  emptyForm = false;

  canEditUser: boolean;
  loadingData = true;

  userSearchString = '';
  userSearchHasError = false;
  userSearchErrorObj = {
    search: false,
    role: false,
    company: false,
  };
  selectedBulkAction = 'Select';
  bulkHasError = false;
  currentBulkAction: AdminBulkAction = {};
  bulkActionMessageDisplay: MessageDisplayModel = new MessageDisplayModel();
  searchMessageDisplay: MessageDisplayModel = new MessageDisplayModel();
  selectedBulkRole = '';

  searchIsWaiting = false;

  // pagination
  pageNumber = 1;
  lastPage = 10;
  pageSize = 25;
  totalRows = 0;
  firstResult: number;
  lastResult: number;

  rolesMap = {};
  roles: string[] = [];
  bulkActionRoles: string[] = [];

  // TODO how do we find out what companies a user can access
  companiesMap = {};
  companies: string[] = [];

  actions: string[] = ['Select', 'Edit', 'Delete'];

  headings: any;

  users: User[] = [];
  records: Array<any> = [];
  userSubscription: Subscription;
  permissionsSubscription: Subscription;
  canViewCompanies = false;

  checkedUserState: number[];

  user: OAuthUserInfo;
  roleName: string;
  selectedRoleString = '';
  selectedCompanyString = '';
  searching = false;

  constructor(
    private router: Router,
    private messageDisplayService: MessageDisplayService,
    private userService: UserService,
    private permissionsService: PermissionService,
    private sessionStorageService: SessionStorageService,
    private adminRolesCompaniesService: AdminRolesCompaniesService,
    private titleService: Title
  ) {
    this.userSubscription = this.sessionStorageService.userInfosChange.subscribe(
      (userInfo: string) => {
        if (userInfo) {
          const user: OAuthUserInfo = JSON.parse(userInfo);
          this.user = user;
        }
      }
    );

    this.permissionsSubscription = this.permissionsService.permissions$.subscribe(
      (permissions: Permissions) => {
        if (permissions) {
          this.canViewCompanies = permissions.canCRUDMasterAdmin;
          this.roleName = permissions.roleName;
          this.canEditUser = permissions.canEditUser;
        }
      }
    );

    this.adminRolesCompaniesService.rolesMap$.subscribe((rolesMap: any) => {
      if (rolesMap) {
        this.rolesMap = rolesMap;
        this.roles = Object.keys(this.rolesMap);
        this.bulkActionRoles = Object.keys(this.rolesMap);
        if (this.roleName === 'Master Servicer Admin') {
          this.bulkActionRoles = [
            'Master Servicer Standard',
            'Master Servicer Limited',
          ];
          this.roles = ['Master Servicer Standard', 'Master Servicer Limited'];
        } else if (this.roleName === 'Vendor Admin') {
          this.bulkActionRoles = ['Vendor Standard', 'Vendor Limited'];
          this.roles = ['Vendor Standard', 'Vendor Limited'];
        }
        this.roles.unshift('All');
      }
    });

    this.adminRolesCompaniesService.companiesMap$.subscribe(
      (companiesMap: any) => {
        if (companiesMap) {
          this.companiesMap = companiesMap;
          this.companies = Object.keys(this.companiesMap);
          this.companies.unshift('All');
        }
      }
    );
  }

  ngOnInit() {
    this.titleService.setTitle('Arvest Business Partner Portal: Admninistration');
    this.loadData(false);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.selectedRoleString = 'All';
      this.selectedCompanyString = 'All';
    }, 500);
  }

  private loadData(addRecords: boolean = false) {
    this.loadingData = true;
    console.log(this.user);
    this.userService
      .searchForUsers(this.buildSearchParams())
      .then((response: UserSearchResponse) => {
        if (this.roleName === 'Master Servicer Admin') {
          this.users = response.records.filter(
            (user) =>
              user.roleName === 'Master Servicer Standard' ||
              user.roleName === 'Master Servicer Limited'
          );
        } else if (this.roleName === 'Vendor Admin') {
          this.users = response.records.filter(
            (user) =>
              user.roleName === 'Vendor Standard' ||
              user.roleName === 'Vendor Limited'
          );
        } else {
          this.users = response.records;
        }
        this.pageNumber = response.pageNumber;

        this.firstResult = 1 + this.pageSize * (response.pageNumber - 1);
        this.lastResult =
          response.records.length + this.pageSize * (response.pageNumber - 1);

        this.totalRows = response.totalRows;

        if (this.totalRows % this.pageSize === 0) {
          this.lastPage = this.totalRows / this.pageSize;
        } else {
          this.lastPage = Math.floor(this.totalRows / this.pageSize) + 1;
        }

        const [headings, newRecords] = AdminUserFactory.formatUsersForTable(
          this.users,
          this.canViewCompanies
        );
        this.headings = headings;

        if (addRecords) {
          this.records = [...this.records, ...newRecords];
        } else {
          this.records = newRecords;
        }

        console.log('Admin Records');
        console.log(this.records);

        this.searchIsWaiting = false;
        this.checkedUserState = [];
        this.loadingData = false;
      })
      .catch((error) => {
        console.log('Got an error fetching users', error);
        this.searchMessageDisplay = this.messageDisplayService.createErrorMessageDisplayWithGivenMessage(
          'Error searching for users'
        );
        this.loadingData = false;
      });
  }

  public fetchNewRecords(newPage: number) {
    this.pageNumber = newPage;
    this.loadData(false);
  }

  public navigateToCreateUser() {
    this.router.navigateByUrl('/admin/create');
  }

  public onSearchFormSubmit() {
    this.searchIsWaiting = true;
    this.pageNumber = 1;
    this.loadData(false);
  }

  public confirmText() {
    return `Are you sure you want to ${this.selectedBulkAction.toLowerCase()} ${this.checkedUserState.length} users? `;
  }

  public validateBulkActionForm(event) {
    if (this.checkedUserState.length === 0) {
      this.bulkActionMessageDisplay = this.messageDisplayService.createErrorMessageDisplayWithGivenMessage(
        'Please select users'
      );
      return false;
    }

    this.bulkActionMessageDisplay = undefined;
    this.confirmDialog.openDialog();
  }

  public confirmationSelection(event) {
    if (event) {
      this.submitBulkActionForm();
    }
  }

  public updateCheckedUsers(checkedState: any) {
    Object.keys(checkedState).forEach((stringIndex: string) => {
      const numericIndex = parseInt(stringIndex, 10);

      // if true, they are currently checked
      if (checkedState[stringIndex]) {
        // if its not already in the array, it needs to be added
        if (this.checkedUserState.indexOf(numericIndex) === -1) {
          this.checkedUserState.push(numericIndex);
        }
      } else {
        // if its in the array, it needs to be taken out
        if (this.checkedUserState.indexOf(numericIndex) !== -1) {
          this.checkedUserState.splice(
            this.checkedUserState.indexOf(numericIndex),
            1
          );
        }
      }
    });
  }

  public submitBulkActionForm() {
    const modifyData = [];

    this.checkedUserState.map((numericIndex: number) => {
      const params: ModifyUserParams = {
        userId: this.users[numericIndex].userId,
        roleId: this.rolesMap[this.selectedBulkRole],
        roleName: this.users[numericIndex].roleName,
        companyId: parseInt(this.users[numericIndex].companyId, 10),
        createdUserID: this.user.sub,
      };

      modifyData.push(params);
    });

    this.userService.modifyUser(this.selectedBulkAction, modifyData).then((result: any) => {
      this.pageNumber = 1;
      this.checkedUserState = [];
      this.tableComponent.clearCheckboxes();
      this.loadData(false);
    });

    this.bulkActionMessageDisplay = this.messageDisplayService.createSuccessMessageDisplayWithGivenMessage(
      'Users updated!'
    );
  }

  public actionFormCanSubmit() {
    return (
      this.selectedBulkAction !== '' &&
      this.selectedBulkAction !== 'Select'
    );
  }

  private buildSearchParams() {
    const returnObj = {
      userId: this.user.sub,
      searchTerm: this.userSearchString,
      roleId: this.selectedRoleString === 'All' || this.selectedRoleString === '' ? '' : this.rolesMap[this.selectedRoleString],
      arvCompanyId: this.selectedCompanyString === 'All' ? '' : this.selectedCompanyString,
      pageNumber: this.pageNumber,
    };

    console.log('SearchParms');
    console.log(returnObj);

    return returnObj;
  }

  public navigateToUser(numericIndex: number) {
    const user = this.users[numericIndex];

    this.router.navigateByUrl(`/admin/edit/${user.userId}`);
  }

  ngOnDestory() {
    this.userSubscription.unsubscribe();
    this.permissionsSubscription.unsubscribe();
  }

  search() {
    this.loadData(false);
  }

  canShowCompanyies() {
    if (this.user && this.user.arvCompanyID === 'Arvest') {
      return true;
    }
    return false;
  }
}
